export default "__VITE_ASSET__BbF4zvwM__"